import {WalletContext} from '#/contexts/wallet-provider';
import {ShareLandMarketContract} from '#/contracts/ShareLandMarketContract';

import {Land} from '@shareland/shareland-common';
import {useContext} from 'react';

export const useLandTokenContract = (land: Land | undefined): ShareLandMarketContract | null => {
  const {
    accountResult: {address},
  } = useContext(WalletContext);

  if (!(address && land)) {
    return null;
  }

  return new ShareLandMarketContract(address, land);
};

export const useLandTokenContracts = (lands: Land[]): ShareLandMarketContract[] => {
  const {
    accountResult: {address},
  } = useContext(WalletContext);

  if (!address) {
    return [];
  }

  return lands.map(land => new ShareLandMarketContract(address, land));
};
